import { useEffect, useState } from "react";
import { Button, CircularProgress, InputLabel, Switch, TextField } from "@mui/material";
import DialogC from "../../../components/Dialog";
import { useForm } from 'react-hook-form'
import { yupResolver } from "@hookform/resolvers/yup";
import { ValidationSchema } from "../services/SchemaValidation"
import { ValidateErrorMessage } from "../../../components/ValidateErrorMessage";
import { useMutation } from 'react-query'
import { editPropertyFacility } from "../../../services/api/PropertyFacility";

export default function Edit({ open, setOpen, facility, reportAction }) {
  const [isLoading, setIsLoading] = useState(false)
  const [dataFacility, setDataFacility] = useState({})
  let { reset, handleSubmit, register, formState: { errors }, setValue }  = useForm({ 
    resolver: yupResolver(ValidationSchema)
  })

  useEffect(() => {
    if(open) {
      setDataFacility(facility)
      setValue("name", facility.name)
      setValue("icon", facility.icon)
      setValue("description", facility.description)
      setValue("active", facility.active)
    }
  }, [open])

  const mutation = useMutation(editPropertyFacility, {
    onSuccess: (data) => {
      setIsLoading(false)
      if(data.status === "error") { reportAction('edit', false, { message: 'Error al editar los datos'}, false)
      } else { reportAction('edit', false, { }, true) }
    }
  })

  const handleEdit = (params) => { 
    console.log("prueba", params)
    console.log("id", dataFacility._id)
    setIsLoading(true)
    mutation.mutate({id: dataFacility._id, params: params})
  }

  const handleClose = () => { reset(); setDataFacility({}); setOpen(false) }

  const handleOnChangeData = (event) => { 
    setDataFacility({...dataFacility, [event.target.name]: event.target.value}) 
  }

  const handleChangeActive = (event) => {
    setDataFacility({...dataFacility, active: !dataFacility.active}) 
  }

  const Actions = () => (<>
    { !isLoading ? <>
      <Button onClick={handleClose}>Cancel</Button>
      <Button variant="contained" color="info" onClick={handleSubmit(handleEdit)}>Editar</Button>
      </> : <CircularProgress /> }
  </>)
  //https://cdn-icons-png.flaticon.com/512/6133/6133429.png
  //https://cloudinary.com/pricing
  return (
    <DialogC open={open} title={`Editar - ${facility.name}`} actions={<Actions />}>
      <>
        <InputLabel htmlFor='name' required style={{ fontSize: 14 }}>Nombre</InputLabel>
        <TextField id='name' fullWidth margin="dense" type="text" name='name'
          value={dataFacility.name || ""}
          {...register(`name`)} 
          error={errors.name ? true: false}
          onChange={handleOnChangeData} />
        <ValidateErrorMessage message={errors.name?.message} />
        <br />
        <InputLabel htmlFor='description' style={{ fontSize: 14 }}>Descripción</InputLabel>
        <TextField id='description' fullWidth margin="dense" type="text" name='description'
          multiline
          maxRows={4}
          value={dataFacility.description || ""}
          {...register(`description`)} 
          error={errors.description ? true: false}
          onChange={handleOnChangeData} />
        <ValidateErrorMessage message={errors.description?.message} />
        <br />
        <div style={{ display: "grid", gridTemplateColumns: "50% 50%"}}>
          <div style={{ textAlign: "center" }}>
            <img src={dataFacility.icon || "/images/picture_empty.png"} style={{ width: "50%" }}/>
          </div>
          <div>
          <InputLabel htmlFor='icon' style={{ fontSize: 14 }}>Icono</InputLabel>
          <TextField id='icon' fullWidth margin="dense" type="text" name='icon'
            value={dataFacility.icon || ""}
            {...register(`icon`)} 
            error={errors.icon ? true: false}
            onChange={handleOnChangeData} />
          <ValidateErrorMessage message={errors.icon?.message} />
          </div>
        </div>
        <br />
        <InputLabel htmlFor='description' required style={{ fontSize: 14 }}>Activo?</InputLabel>
        <Switch edge="end" inputProps={{ 'aria-labelledby': `switch-list-label-active` }}
          onClick={handleChangeActive}
          checked={dataFacility.active || false} 
          {...register(`active`)} 
        />
      </>
    </DialogC>
  )
}